import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import Helmet from 'react-helmet';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigurationKey = 'mmPlayer';

interface MMPlayerDataProps {
  html: string;
  dataId?: string;
}

export interface MMPlayerThemeProps {
  backgroundColor: string;
}

export type MMPlayerProps = MMPlayerDataProps & MandatoryAdditionalStyle;


const createMMPlayerWrapperStyle = (backgroundColor: string) => StyleSheet.create({
  style: {
    backgroundColor,
    paddingTop: `calc(100% / (${16 / 9}))`,
    position: 'relative',
    margin: 0,
  },
});

const createMMPlayerStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

export const MMPlayer: React.FunctionComponent<MMPlayerProps> = props => {
  const { html, additionalStyle, dataId } = props;
  const { backgroundColor } = useTheme<MMPlayerThemeProps>(componentConfigurationKey);
  const MMPlayerWrapperStyle = createMMPlayerWrapperStyle(backgroundColor);
  const MMPlayerStyle = createMMPlayerStyle();
  return (
    <ErrorBoundary>
      <Helmet>
        <script async defer src="https://vms-players.minutemediaservices.com/mplayer_embed_mount.js" />
      </Helmet>
      <figure data-id={dataId} className={css(additionalStyle.style)}>
        <div className={css(MMPlayerWrapperStyle.style)}>
          {/* eslint-disable-next-line react/no-danger */}
          <div className={css(MMPlayerStyle.style)} dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </figure>
    </ErrorBoundary>
  );
};
